import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'svc-nissan-dashboard',
  templateUrl: './nissan-dashboard.component.html',
  styleUrls: ['./nissan-dashboard.component.scss'],
})
export class NissanDashboardComponent implements OnInit, OnChanges {
  vehicleInfoUi: any = { collapsed: false };
  customerInfoUi: any = { collapsed: true };
  outstandingServiceUi: any = { collapsed: true };
  warrantyUi: any = { collapsed: true };
  extendedCoveragesUi: any = { collapsed: true };
  nationalServiceHistoryUi: any = { collapsed: true };
  appliableTSBUi: any = { collapsed: true };

  @Input() collapsed: boolean;
  constructor(public serviceLaneFacade: ServiceLaneFacade) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.collapsed) {
      if (changes.collapsed.currentValue) {
        this.vehicleInfoUi.collapsed = changes.collapsed.firstChange ? false : true;
        this.customerInfoUi.collapsed = true;
        this.outstandingServiceUi.collapsed = true;
        this.warrantyUi.collapsed = true;
        this.extendedCoveragesUi.collapsed = true;
        this.nationalServiceHistoryUi.collapsed = true;
        this.appliableTSBUi.collapsed = true;
      } else {
        this.vehicleInfoUi.collapsed = false;
        this.customerInfoUi.collapsed = false;
        this.outstandingServiceUi.collapsed = false;
        this.warrantyUi.collapsed = false;
        this.extendedCoveragesUi.collapsed = false;
        this.nationalServiceHistoryUi.collapsed = false;
        this.appliableTSBUi.collapsed = false;
      }
    }
  }

  toggleCollapse(groupUiObject: any) {
    groupUiObject.collapsed = !groupUiObject.collapsed;
  }

  getOwnerCenterStatus(ownerCenterStatus: string) {
    let status: any = {};
    switch (ownerCenterStatus) {
      case 'NOT_FOUND':
        status = {
          class: 'danger',
          icon: 'warning',
          description: 'Owner Center account not found. Insufficient customer information',
        };
        break;
      case 'MISSING_INFO':
        status = {
          class: 'danger',
          icon: 'warning',
          description: 'Insufficient customer information',
        };
        break;
      case 'NOT_SUPPORTED':
        status = {
          class: 'danger',
          icon: 'warning',
          description: 'Owner Center account status cannot be determined',
        };
        break;
      case 'UNKNOWN':
        status = {
          class: 'danger',
          icon: 'warning',
          description: 'Owner Center account status is unknown',
        };
        break;

      case 'OWNER_CENTER':
      case 'ONSTAR_AND_OWNERCENTER':
        status = {
          class: 'pass',
          icon: 'done',
          description: 'Customer has an Owner Center account',
        };
        break;

      default:
        status = {
          class: 'warning',
          icon: 'warning',
          description: 'Unknown Owner Center account status',
        };
    }
    return status;
  }

  isArray(array: any[]) {
    return Array.isArray(array);
  }
}
